import { createContext, FC, PropsWithChildren, useContext } from 'react';

export type LanguageContextValue = {
  language: string;
  languages: string[];
};

export const LanguageContext = createContext<LanguageContextValue>({
  language: 'de',
  languages: ['de'],
});

export const useLang = () => useContext(LanguageContext);

export const LanguageProvider: FC<PropsWithChildren & { lang: string; languages: string[] }> = ({
  children,
  lang,
  languages = [lang]
}) => {
  return (
    <LanguageContext.Provider value={{ language: lang, languages }}>
      {children}
    </LanguageContext.Provider>
  );
};